import React, {createRef, useState} from 'react';
import Grid from "@mui/material/Grid2";
import {CardContent, CircularProgress, Modal, Paper} from "@mui/material";
import {DeleteOutline, DrawOutlined, FileUploadOutlined} from "@mui/icons-material";
import FunctionHandler from "../../../utils/functionHandler";
import UserManager, {useUserData} from "../../../managers/userManager/userManager";
import CartManager from "../../../managers/cartManager/cartManager";
import PhotoEditor from "../../../photoEditor/PhotoEditor";
import Typography from "@mui/material/Typography";
import {Trans} from "react-i18next";
import ImageLoader from "../../../components/imageLoader/ImageLoader";
import Box from "@mui/material/Box";

const fileTypes = ["JPG", "JPEG", "PNG", "SVG", "WEBP"];

function MyDesigns(props) {
    const userData = useUserData();
    const inputRef = createRef();
    const handleClick = React.useCallback(() => inputRef.current?.click(), [inputRef]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const removeDesign = (index) => {
        userData.cart.designs.splice(index, 1);
        UserManager.setDesigns(userData.cart.designs);
        CartManager.setDesigns(userData.cart.designs)
    }

    const getDesigns = () => {
        return userData.cart.designs.map((src, index) => {
            return <Grid key={src}
                         sx={{
                             padding: '2px',
                             border: '2px solid',
                             borderColor: 'transparent'
                         }}>
                <Paper>
                    <ImageLoader src={FunctionHandler.getFunctionUrl(`/dep/${encodeURIComponent('thumbnail/')}${src.replace(/.svg$/, '.png')}`)}
                                 fallbackSrc={FunctionHandler.getFunctionUrl(`/dep/${src}`)}
                                 sx={{
                        width: 50,
                        height: 50,
                        cursor: 'pointer'
                    }}/>
                    <CardContent className="" sx={{
                        width: 50,
                        height: 50,
                        borderRadius: '5%',
                        cursor: 'pointer',
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        "&:hover": {
                            opacity: 1,
                        }
                    }} onClick={() => removeDesign(index)}>
                        <DeleteOutline
                            sx={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}
                            color="secondary"/>
                    </CardContent>
                </Paper>
            </Grid>
        });
    }

    const onFileUpload = (event) => {
        const formData = new FormData();
        Array.from(event.target.files).forEach(file => {
                formData.append('file', file);
            }
        );
        setLoading(true);

        FunctionHandler.sendFile('/upload', formData, (data) => {
            CartManager.addDesignsPath(data.uploadedFiles);
            setLoading(false);
        });

        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.type = "text";
            inputRef.current.type = "file";
        }
    }

    const handleOpenModal = () => {
        setOpen(true);
    }

    const handleCloseModal = () => {
        setOpen(false);
    }

    const closeEditor = (svg) => {
        handleCloseModal();
        setLoading(true);
        if (svg) {
            FunctionHandler.sendData('/uploadSvg', {svg}, (data, err) => {
                if (!err) {
                    CartManager.addDesignPath(data.filePath);
                    setLoading(false);
                }
            });
        }
    }

    return (userData?.cart?.designs && <>
            {loading ? <Box sx={{
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100,
                backgroundColor: 'rgba(0, 0, 0, 0.35)'
            }}><CircularProgress/></Box> : ''}
            <Typography variant="body2" sx={{pb: 1}} key={"warning"}>
                <Trans i18nKey={'design.warning'}/>
            </Typography>
            <Grid
                container
                flexDirection="column"
                justifyContent="space-between"
                sx={{minHeight: {sm: 450}, height: {xs: '100%'}}}
            >
                <Grid container gap={2}>
                    <Grid sx={{
                        padding: '2px',
                        border: '2px solid',
                        borderColor: 'transparent'
                    }}>
                        <CardContent sx={{
                            width: 50,
                            height: 50,
                            cursor: 'pointer',
                            border: '2px dashed',
                            borderColor: 'primary.main'
                        }} onClick={handleOpenModal}>
                            <DrawOutlined sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }} color="secondary"/>
                        </CardContent>
                    </Grid>
                    <Grid sx={{
                        padding: '2px',
                        border: '2px solid',
                        borderColor: 'transparent'
                    }}>
                        <CardContent sx={{
                            width: 50,
                            height: 50,
                            cursor: 'pointer',
                            border: '2px dashed',
                            borderColor: 'primary.main'
                        }} onClick={handleClick}>
                            <FileUploadOutlined sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)'
                            }} color="secondary"/>
                            <input type="file" style={{display: 'none'}} ref={inputRef}
                                   onChange={onFileUpload}
                                   accept={fileTypes.map(ext => `image/${ext}`).join(', ')}
                                   multiple={true}/>
                        </CardContent>
                    </Grid>
                    {getDesigns()}
                </Grid>

                <Modal
                    open={open}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                >
                    <Paper
                        sx={{width: {xs: '100%', sm: 500}, maxHeight: '100%', overflowY: 'auto', overflowX: 'hidden'}}>
                        <CardContent sx={{
                            height: {xs: '100%', sm: 'initial'},
                            p: 0,
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        }}>
                            <PhotoEditor closeEditor={closeEditor} fileTypes={fileTypes}/>
                        </CardContent>
                    </Paper>
                </Modal>
            </Grid>
        </>
    );
}

export default MyDesigns;
